import { useState } from "react";
import { toast } from "sonner";
import { submitContact } from "../lib/api";
import { logError } from "../lib/logger";

const initialState = {
    name: "",
    email: "",
    phone: "",
    subject: "General Enquiry",
    message: "",
};

export function useContactForm() {
    const [form, setForm] = useState(initialState);
    const [loading, setLoading] = useState(false);

    const change = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await submitContact(form);
            toast.success("Thanks — our team will respond within 24 hours.");
            setForm(initialState);
        } catch (err) {
            logError("Contact form submit failed:", err);
            toast.error("Could not send. Please try again or email us directly.");
        } finally {
            setLoading(false);
        }
    };

    return { form, loading, change, submit };
}
